import React, { useEffect, useState } from "react";

interface TextInputProps {
  placeholderStr: string;
  type?: "text" | "number" | "textarea";
  value?: string;
  extraCssClass?: string;
  maxStrLength?: number;
  required?: boolean;
  onChange: (arg?: any) => any | void;
}

const TextInput = ({
  placeholderStr,
  type = "text",
  extraCssClass = "",
  maxStrLength,
  required,
  onChange,
  ...props
}: TextInputProps) => {
  const [value, setValue] = useState("");
  const [stateClass, setStateClass] = useState("");

  useEffect(() => {
    if (required) editBorderColor(value.length != 0);
  }, [required]);

  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);

  function handleChange(event) {
    onChange(event);
    if (!maxStrLength) {
      onChange(event);
      setValue(event.target.value);
    } else if (event.target.value.length < maxStrLength) {
      onChange(event);
      setValue(event.target.value);
    } else {
      setStateClass("");
      setStateClass("product-section__input-shake");
      setTimeout(() => {
        setStateClass("");
        // wait time should correspond with the one of the keyframe in scss
      }, 700);
    }
  }

  function handleInputStyleChange(e) {
    editBorderColor(e.target.value != 0);
  }

  function editBorderColor(valid) {
    if (valid) {
      setStateClass("border-success");
    } else {
      setStateClass("border-danger");
    }
  }

  function autoGrow(e) {
    e.target.style.height = window.innerWidth < 768 ? "50px" : "62px";
    e.target.style.height = e.target.scrollHeight + "px";
  }

  return type == "textarea" ? (
    <textarea
      className={`product-section__input ${extraCssClass} ${stateClass}`}
      placeholder={placeholderStr}
      onChange={(e) => {
        autoGrow(e);
        handleInputStyleChange(e);
        handleChange(e);
      }}
      onFocus={(e) => {
        setStateClass("border-primary");
      }}
      onBlur={handleInputStyleChange}
      {...props}
      value={value}>
      {value}
    </textarea>
  ) : (
    <input
      type={type}
      className={`product-section__input ${extraCssClass} ${stateClass}`}
      placeholder={placeholderStr}
      onChange={(e) => {
        handleInputStyleChange(e);
        handleChange(e);
      }}
      onFocus={(e) => {
        setStateClass("border-primary");
      }}
      onBlur={handleInputStyleChange}
      {...props}
      value={value}
    />
  );
};

export default TextInput;
